export default __webpack_public_path__ + "static/media/meal-icon.b28638fd.svg";